module.exports = __webpack_public_path__ + "img/01.209b5678.jpg";